@if (editOnly()) {
<div class="row  normal-row row-header led-odd">{{meta()?.index | tkdata:'ai':{'default': meta()?.omschrij?.toString()} | async }}</div>
<div class="row  normal-row">
    <kendo-label text="Type" style="display: flex;">
        <kendo-dropdownlist [data]="this.aiTypes()" [valuePrimitive]="true" [value]="this.editValue.typeIndex"
            [valueField]="'index'" (valueChange)="onTypeChanged($event)" [textField]="'omschrij'"></kendo-dropdownlist>
    </kendo-label>
    <div>
        <kanaal-input [virtualAI]="this.isVirtual"
            [assignement]="this.assignment()"
            [autofilKanaal]="this.autoFill()"
            [initialValue]="{ ioType: this.kanaalType, range: this.editValue.range, start: this.editValue.kanaal}"
            (valueChanged)="onKanaalInputChanged($event)"></kanaal-input>
    </div>

</div>

} @else if (isNew()) {
@if (this.aiOptions().length != 0) {
<div class="row">
    <meta-select-button [availableMetas]="this.aiOptions()" [alreadySelected]="this.alreadySelectedFN()"
        (onSelect)="onNew($event)" [labelCbObs]="this.labelFn()" />
</div>
}
} @else {
<div class="row condensed clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="open()">
    <div [title]="meta()?.index">{{meta()?.index | tkdata:'ai':{'default': meta()?.omschrij?.toString()} | async }} 
        @if (!this.onlyDesc()) {
        : {{kanaal()}} : {{typeDesc()}}

        }

    </div>
</div>
}
<kendo-dialog *ngIf="this.isEditing" title="Edit {{meta()?.index | tkdata:'ai':{'default': meta()?.omschrij?.toString()} | async }}" width="500px" (close)="this.close()"
    autoFocusedElement="#dtype input">
    <div>
        <div>{{meta()?.index | tkdata:'ai':{'default': meta()?.omschrij?.toString()} | async }} : {{kanaal()}} : {{typeDesc()}}</div>
        <div class="row">
            <kendo-label text="Type">
                <kendo-dropdownlist [data]="this.aiTypes()"  [valuePrimitive]="true"
                    [value]="this.editValue.typeIndex" [valueField]="'index'" (valueChange)="onTypeChanged($event)"
                    [textField]="'omschrij'"></kendo-dropdownlist>
            </kendo-label>
        </div>
        <kanaal-input [virtualAI]="this.isVirtual" id="dtype"
            [assignement]="this.assignment()"
            [initialValue]="{ ioType: this.kanaalType, range: this.editValue.range, start: this.editValue.kanaal}"
            (valueChanged)="onKanaalInputChanged($event)"></kanaal-input>
        <kendo-dialog-actions>
            <button kendoButton (click)="this.close()">Cancel</button>
            <button kendoButton (click)="onDelete()" themeColor="primary" *ngIf="!isNew()">
                Delete
            </button>
            <button kendoButton (click)="onSave()" themeColor="primary">
                Save
            </button>
        </kendo-dialog-actions>
    </div>
</kendo-dialog>